import type { SVGProps } from "react";
import * as React from "react";

const SvgCloudRain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cloud-rain_svg__a)">
      <path
        fill="currentColor"
        d="M17 13a1 1 0 1 0-2 0zm-2 8a1 1 0 1 0 2 0zm-6-8a1 1 0 1 0-2 0zm-2 8a1 1 0 1 0 2 0zm6-6a1 1 0 1 0-2 0zm-2 8a1 1 0 1 0 2 0zm8.599-7.336a1 1 0 1 0 .802 1.832zM18 7l.001-1H18zm-1.26 0-.968.25a1 1 0 0 0 .968.75zM3.376 16.031a1 1 0 1 0 1.248-1.562zM15 13v8h2v-8zm-8 0v8h2v-8zm4 2v8h2v-8zm9.401 2.496a6 6 0 0 0 2.926-2.746l-1.778-.917a4 4 0 0 1-1.95 1.831zm2.926-2.746a6 6 0 0 0 .54-3.976l-1.957.409a4 4 0 0 1-.36 2.65zm.54-3.976a6 6 0 0 0-2.086-3.428L20.52 8.897a4 4 0 0 1 1.39 2.285zm-2.086-3.428A6 6 0 0 0 18.001 6L18 8a4 4 0 0 1 2.52.897zM18 6h-1.26v2H18zm-.292.75a9 9 0 0 0-1.983-3.724L14.23 4.354a7 7 0 0 1 1.543 2.896zm-1.983-3.724A9 9 0 0 0 12.263.615l-.726 1.863a7 7 0 0 1 2.692 1.876zM12.263.615a9 9 0 0 0-4.18-.568l.202 1.99a7 7 0 0 1 3.252.441zM8.083.047a9 9 0 0 0-3.98 1.399l1.086 1.679a7 7 0 0 1 3.096-1.089zm-3.98 1.399a9 9 0 0 0-2.906 3.06l1.733.998a7 7 0 0 1 2.26-2.38zm-2.906 3.06A9 9 0 0 0 .005 8.552l1.998.1a7 7 0 0 1 .927-3.149zM.005 8.552a9 9 0 0 0 .784 4.145l1.823-.822a7 7 0 0 1-.61-3.224zm.784 4.145a9 9 0 0 0 2.587 3.333l1.248-1.562a7 7 0 0 1-2.012-2.592z"
      />
    </g>
    <defs>
      <clipPath id="cloud-rain_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCloudRain;
